import {
    USER_CHOOSE_CURRENT_FRUI_QPXH,
} from './constants';
  
export function chooseCurrentFrui_qpxh(modal) {
    return {
      type: USER_CHOOSE_CURRENT_FRUI_QPXH,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case USER_CHOOSE_CURRENT_FRUI_QPXH:
        return {
          ...state,
          currentFrui_qpxh:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/user/redux/chooseCurrentFrui_qpxh.js